import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".mySwiper", {
    spaceBetween: '2.16%',
    slidesPerGroup: 3,
    slidesPerView: 3,
    speed:700,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: '2.16%',
        },
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 20,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 10,
        }
    }
});